module.exports = __webpack_public_path__ + "img/hr-tree-07-e-trunk.dcbeeac9.png";